// Withdrawal risk (P1-D19): he A scores every withdrawal at request time (backend/lib/rut_rui_ro.js) and
// again when the CMS holds it. canXacNhan = the reviewer must tick the confirmation.
export type WithdrawRisk = {
  diem: number; lyDo: { ma: string; diem: number; chu: string }[]; lanDau: boolean; canXacNhan: boolean;
  may: { ip?: string; fg?: string }; xacNhan: string | null;
};

// A refused approve (409 RISK_ACK) carries the score he A just computed. An order from before P1-D19
// stores no score, and a lowered threshold changes it: the screen must take this one, or the
// confirmation never shows and every approve is refused again.
export function riskFromRefusal(e: unknown): WithdrawRisk | null {
  const x = e as { status?: number; code?: string; details?: { ruiRo?: WithdrawRisk | null } } | null;
  if (!x || x.code !== 'RISK_ACK') return null;
  const r = x.details?.ruiRo;
  return r && typeof r === 'object' && r.canXacNhan ? r : null;
}

// P1-D20: open risk-queue events that froze the player's withdrawals (rule label, when). he A holds none of
// the player's withdrawals until they are cleared with the freeze released.
export type RiskHold = { id: string; rule: string; label: string; at: string };

// owner 2026-10-03: nothing refuses a withdrawal approval, every reason is a risk the reviewer ticks. The API lists them
// (GET /api/admin/wallet/:id/risks) and refuses an approve without both ticks and every code seen (409 RISK_ACK, carrying
// the fresh list).
export type RiskKind = 'lock' | 'freeze' | 'hold' | 'bets' | 'wagering' | 'blocklist' | 'rule' | 'score' | 'other';
export type RiskItem = { code: string; kind: RiskKind; label: string };
export const RISK_KIND_LABEL: Record<RiskKind, string> = {
  lock: 'Đã khóa', freeze: 'Dừng rút', hold: 'Giữ rút (rủi ro)', bets: 'Cược chưa chốt', wagering: 'Vòng cược',
  blocklist: 'Danh sách chặn', rule: 'Luật rút', score: 'Điểm rủi ro', other: 'Rủi ro khác',
};

// A refused approve (409 RISK_ACK) carries the list as it is now: the screen takes it and clears the ticks, so a risk that
// appeared after the dialog loaded is read before it can be approved.
export function risksFromRefusal(e: unknown): RiskItem[] | null {
  const x = e as { code?: string; details?: { risks?: RiskItem[] } } | null;
  if (!x || x.code !== 'RISK_ACK' || !Array.isArray(x.details?.risks)) return null;
  return x.details.risks;
}

// One tick (owner 2026-10-04, rút 1 bước): "I checked the risks above and take responsibility" when the list is not empty.
export function ticksDone(items: RiskItem[], daNhan: boolean): boolean {
  return !items.length || daNhan;
}

// Rút 1 bước: the claim of an open lobby withdrawal (POST /api/admin/wallet/:id/claim). `previous` = another admin opened it
// before and the claim ran out, `takenFrom` = the founder took it over from that admin: both may have transferred already.
export type Claim = {
  status: string; by: string | null; until: string | null; mine: boolean; ttlMin: number | null;
  takenFrom: string | null; previous: { by: string; until: string | null } | null;
};

// The dialog renews its claim while open: every third of the claim time, at least every 15 s (a founder takeover then
// shows on the old holder's screen within 15 s and locks its copy buttons).
export function renewEveryMs(ttlMin: number | null | undefined): number {
  const ttl = Number(ttlMin) > 0 ? Number(ttlMin) * 60_000 : 60_000;
  return Math.max(5_000, Math.min(15_000, Math.floor(ttl / 3)));
}

// Whose earlier handling the reviewer must check the bank statement for before transferring (takeover or expired claim).
export function earlierHandler(c: Claim | null | undefined): string | null {
  return c?.mine ? c.takenFrom ?? c.previous?.by ?? null : null;
}
